import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DAILY STAFF ATTENDANCE VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verification Attendance Inbox (GET)
export const getVerificationAttendance = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            Roleid: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerificationAttendance?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Attendance by Transaction Number (GET)
export const getAttendanceByTransactionNo = async (params) => {
    try {
        const { transNo } = params;
         // DEBUG
        
        // Validate required parameters
        if (!transNo) {
            throw new Error('TransNo is required');
        }
        
        const queryParams = new URLSearchParams({
            TransNo: transNo.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetAttendancebyTransactionNo?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve Staff Attendance (PUT)
// 3. Approve Staff Attendance (PUT)
export const approveStaffAttendance = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.TransactionNo) {
            throw new Error('TransactionNo is required');
        }
        if (!params.CostCenter) {
            throw new Error('CostCenter is required');
        }
        if (!params.AttendanceDate) {
            throw new Error('AttendanceDate is required');
        }
        if (!params.EmployeeIds) {
            throw new Error('EmployeeIds is required');
        }
        if (!params.Attendancetypes) {
            throw new Error('Attendancetypes is required');
        }
        if (!params.RoleId) {
            throw new Error('RoleId is required');
        }
        if (!params.Createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        
        const payload = {
            TransactionNo: params.TransactionNo.toString().trim(),
            CostCenter: params.CostCenter.toString().trim(),
            AttendanceDate: params.AttendanceDate.toString().trim(),
            EmployeeIds: params.EmployeeIds.toString().trim(),
            Attendancetypes: params.Attendancetypes.toString().trim(),
            RoleId: parseInt(params.RoleId),
            Createdby: params.Createdby.toString().trim(),
            Action: params.Action.toString().trim(),
            ApprovalNote: params.ApprovalNote?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveStaffAttendance`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};